$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
animateElementsInView();

// https://stackoverflow.com/questions/12410062/check-if-infowindow-is-opened-google-maps-v3
if ( typeof google !== 'undefined' ) {
	google.maps.InfoWindow.prototype.isOpen = function(){
		var map = this.getMap();
		return (map !== null && typeof map !== "undefined");
	}
	
	
}

function animateElementsInView() {
	$('[data-map-load-on-view]').each(function () {
		
		if ( $(this).hasClass('in-view') ) {
			return;	
		}
		
		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;
			
			$(elementToAnimate).addClass('in-view'); // log that this element has been seen
			
			
			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);
			
			
			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}
	
	var rect = el.getBoundingClientRect();
	
	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;
	
	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}


function buildMap(theMap) {
	$(theMap).each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;
		var directionsService, directionsRenderer;
		
		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}
				
		if ( window.innerWidth < 640 ) {
			zoom = $(this).data('map-zoom-mobile') || 12;
		} else {
			zoom = $(this).data('map-zoom') || 8;
		}
		
		var mapStyle = [{featureType:"water",elementType:"geometry",stylers:[{color:"#e9e9e9"},{lightness:17}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:20}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21}]},{elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]}];
		
		map = new google.maps.Map($(this)[0], {
			center: {lat: centerLat, lng: centerLng},
			zoom: zoom,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: mapStyle
		});
	
		console.log(mapStyle);
	
		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});
			
			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}
		
		var markers = [];
		var infoWindows = [];
		var markerCount = 0;
		
		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map,
				markerId: markerCount
			});
			
			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
			
			var infoWindow = new google.maps.InfoWindow({
				content: $(this).find('[data-map-info-window]').html()
			});
			
			//infoWindow.open(map, marker);
			marker.addListener("click", function () {
				if ( infoWindows[this.markerId].isOpen() ) {
					// Already open, so close this one
					infoWindows[this.markerId].close();
				} else {
					// Make sure all are closed before opening this one
					for ( i=0; i<infoWindows.length; i++ ) {
						infoWindows[i].close();
					}
					infoWindows[this.markerId].open(map, this);
				}
			});
			
			
			markers.push(marker);
			infoWindows.push(infoWindow);
			
			markerCount++;
		});
		
		
		
		
		
		
		if (typeof $(this).data('area-map') != 'undefined') {
			$('.area-map__item-number').remove(); // clear the previous numbers
			
			$('.area-map__item:visible').each(function () {
				$(this).data('marker-id', markerCount);
				$(this).prepend('<div class="area-map__item-number">' + (markerCount + 1) + '</div>');
				
				if (typeof $(this).data('map-marker-coords') != 'undefined') {
					markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
					markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
				} else {
					markerLat = 0;
					markerLng = 0;
				}
				
				marker = new google.maps.Marker({
					position: {lat: markerLat, lng: markerLng},
					map: map,
					markerId: markerCount,
					label: {
						text: String(markerCount + 1),
						color: "white"
					}
				});
				marker.setIcon('/assets/img/area-map-marker.svg');
				
				marker.addListener("click", function () {
					if ( infoWindows[this.markerId].isOpen() ) {
						// Already open, so close this one
						infoWindows[this.markerId].close();
					} else {
						// Make sure all are closed before opening this one
						for ( i=0; i<infoWindows.length; i++ ) {
							infoWindows[i].close();
						}
						infoWindows[this.markerId].open(map, this);
						
						// Find the content div with the directions info for this marker
						var markerId = this.markerId;
						$('.area-map__item').each(function () {
							if ( $(this).data('marker-id') == markerId ) {
								getAreaMapDirections($(this), markerId);
							}
						});						
					}
				});
				
				var infoWindow = new google.maps.InfoWindow({
					content: $(this).find('.area-map__item-info-window').html()
				});
				
				markers.push(marker);
				infoWindows.push(infoWindow);
				
				markerCount++;
			});
			
			
			$('.area-map__item').on('click', function () {
				var markerId = $(this).data('marker-id');
				console.log(markerId);
				
				if ( infoWindows[markerId].isOpen() ) {
					// Already open, so close this one
					infoWindows[markerId].close();
				} else {
					// Make sure all are closed before opening this one
					for ( i=0; i<infoWindows.length; i++ ) {
						infoWindows[i].close();
					}
					infoWindows[markerId].open(map, markers[markerId]);
					getAreaMapDirections(this, markerId);
				}
			});
			
			
			directionsService  = new google.maps.DirectionsService();
			directionsRenderer = new google.maps.DirectionsRenderer({
				polylineOptions: {
					strokeColor: 'red'
				},
				suppressMarkers: true
			});
			directionsRenderer.setMap(map);
			
			
			function getAreaMapDirections(markerItem, markerId) {
				var directionsRequest = {
					origin: $('[data-area-map]').data('map-marker-coords'),
					destination: $(markerItem).data('map-marker-coords'),
					travelMode: google.maps.TravelMode.WALKING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};
				
				directionsService.route(directionsRequest, function(result, status) {        
					if (status == google.maps.DirectionsStatus.OK) {
						directionsRenderer.setDirections(result);
						$(markerItem).find('.walking-time').text( result.routes[0].legs[0].duration.text );
						infoWindows[markerId].setContent( $(markerItem).find('.area-map__item-info-window').html() ); 
					} else {
						console.log('Direction error', result, status);
					}
				});
			}
		}
		
		
		
		
		
		
		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));
			
			var directionsTo = $(this).data('map-directions-destination');
			
			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};
				
				directionsService.route(directionsRequest, function(result, status){        
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});
				
				return false;
			});
		}
	});
}


